import $ from "jquery";
export function accordion() {
  /* Accordion Begin */

  $(".accordion-item__title-wrapper").click(function (e) {
    e.preventDefault();
    var parent = $(this).parent(".accordion-item");

    if (parent.hasClass("accordion-item--active")) {
      $(this).next().slideUp();
      parent.removeClass("accordion-item--active");
    } else {
      $(".accordion-item").removeClass("accordion-item--active");
      parent.toggleClass("accordion-item--active");
      $(".accordion-item__text").slideUp();
      $(this).next().slideDown();
    }
  });

  /* Accordion End */
}
